import { useContext } from 'react';
import { Button, Col, Flex, Row } from 'antd';
import { TextL, TextS } from 'components/Text';
import { useTheme } from 'styled-components';
import { UploadCsvProviderContext } from './ImportCsvModal';
import { IoInformationCircleOutline } from 'react-icons/io5';
import ChargeReviewTable, { IFileRecord } from './ChargeReviewTable';

const ChargesReview = () => {
	const { onClose, handleConfirmImport, file, isPending } = useContext(
		UploadCsvProviderContext,
	);
	const theme = useTheme();

	const fileRecords: IFileRecord[] = file
		? [
				{
					key: 'name',
					label: 'Arquivo',
					value: file.name,
				},
				{
					key: 'size',
					label: 'Tamanho',
					value: `${(file.size / 1024).toFixed(2)} KB`,
				},
				{
					key: 'type',
					label: 'Tipo',
					value: file.type || 'text/csv',
				},
			]
		: [];

	return (
		<Flex style={{ width: '100%', flexDirection: 'column' }} gap={20}>
			<Col style={{ width: '100%' }}>
				<Row style={{ marginBottom: '1.4rem' }}>
					<TextL weight="bold">
						Você tem certeza que deseja realizar a transferência?
					</TextL>
				</Row>
				<ChargeReviewTable data={fileRecords} />

				<div
					style={{
						background: '#FFF4E5',
						border: '1px solid #FFD8A8',
						borderRadius: 16,
						padding: 16,
						marginTop: 16,
						display: 'flex',
						alignItems: 'flex-start',
						justifyContent: 'flex-start',
						gap: 8,
					}}
				>
					<div>
						<IoInformationCircleOutline
							size={'1.4rem'}
							color={'#cca371'}
						/>
					</div>
					<TextS color={theme.text}>
						Após o processamento do arquivo, é necessário realizar a
						aprovação imediata das transferências. Caso isso não
						ocorra, o limite de Pix pode ser bloqueado devido à
						quantidade de consultas realizadas no DICT
					</TextS>
				</div>

				<Row style={{ marginTop: '1rem' }}>
					<Flex
						gap={12}
						align="center"
						justify="flex-end"
						style={{ width: '100%' }}
					>
						<Button
							onClick={onClose}
							type="default"
							style={{ border: 0 }}
						>
							<TextS style={{ color: theme.primary }}>
								Cancelar
							</TextS>
						</Button>
						<Button
							type="primary"
							loading={isPending}
							onClick={handleConfirmImport}
						>
							<TextS style={{ color: theme.white }}>
								Confirmar importação
							</TextS>
						</Button>
					</Flex>
				</Row>
			</Col>
		</Flex>
	);
};

export default ChargesReview;
